<template>
  <GhostComponent
    v-for="(owner, index) in owners"
    :key="owner.id"
    :global-id="owner.id"
    component-name-when-active="ProfileInfoCard"
  >
    <div class="tw-max-w-[200px]">
      <a>
        {{ owner.name }}
        <template v-if="index < owners.length - 1"><br /></template>
      </a>
    </div>
  </GhostComponent>
</template>

<script>
import gql from 'graphql-tag'
import { graphqlFragmentValidator } from '@/utils/propValidation'
import GhostComponent from '@/components/GhostComponent.vue'

const fragment = gql`
  fragment OwnerFragment on User {
    name
    id
  }
`

const gqlValidator = graphqlFragmentValidator(fragment)

export default {
  fragments: {
    ownerFragment: fragment,
  },
  components: {
    GhostComponent,
  },
  props: {
    owners: {
      required: true,
      type: Array,
      validator: (owners) => owners.every(gqlValidator),
    },
  },
}
</script>
